import useTimeoutWhen from "@rooks/use-timeout-when"
import { useState } from "react"
import { floatUpAndGrow } from "shared/styles/keyframes"
import { getRandomInt } from "shared/utils/getRandomInt"
import styled from "styled-components"

import HeartSVG from "../assets/heart.svg"

type StyledHeartProps = {
  width: number
  left: number
  timeout: number
}

const StyledHeart = styled(HeartSVG)<StyledHeartProps>`
  opacity: 0;
  position: absolute;
  bottom: 0;
  width: ${(props) => props.width}px;
  left: calc(50% - ${(props) => props.left}px);
  pointer-events: none;
  animation: ${floatUpAndGrow} ${(props) => props.timeout}ms ease-out
    forwards;

  @for $i from 1 through 10 {
    &:nth-child(#{$i}) {
      animation-delay: $i * 0.2s;
    }
  }
`

type HeartProps = {
  animationDuration: number
}

const Heart = ({ animationDuration }: HeartProps) => {
  const [width] = useState(getRandomInt(10, 40))
  const [left] = useState(getRandomInt(-100, 100))

  return (
    <StyledHeart width={width} left={left} timeout={animationDuration} />
  )
}

type HeartsProps = {
  timeout: number
  onComplete: () => void
}

const Hearts = ({ timeout, onComplete }: HeartsProps) => {
  const [numberOfHearts] = useState(getRandomInt(6, 10))
  useTimeoutWhen(onComplete, timeout, true)

  return (
    <>
      {[...Array(numberOfHearts)].map((heart, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Heart animationDuration={timeout} key={index} />
      ))}
    </>
  )
}

export default Hearts
